import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DataAttributeDirective } from '@shared/directives/data-attribute.directive';
import { HeaderUserInfoComponent } from './components/header-user-info/header-user-info.component';
import { HeaderSearchComponent } from './components/header-search/header-search.component';
import { HeaderScrollMenuComponent } from './components/header-scroll-menu/header-scroll-menu.component';
import { PageHeaderBaseComponent } from './base/page-header-base/page-header-base.component';
import { BalanceInfoDialogService } from './components/header-user-info/services/balance-info-dialog.service';
import { ShowOnPlatformNarrowDirective } from '@shared/directives/show-on-platform-narrow.directive';
import { HeaderSearchCompactComponent } from './components/header-search-compact/header-search-compact.component';

@Component({
  selector: 'tiss-page-header',
  imports: [
    DataAttributeDirective,
    HeaderUserInfoComponent,
    HeaderSearchComponent,
    HeaderScrollMenuComponent,
    ShowOnPlatformNarrowDirective,
    HeaderSearchCompactComponent,
  ],
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [BalanceInfoDialogService],
})
export class PageHeaderComponent extends PageHeaderBaseComponent {}
